// extracted by mini-css-extract-plugin
export var body = "_fg-5";
export var closeButton = "_fg-f";
export var container = "_fg-1";
export var content = "_fg-2";
export var cta = "_fg-c";
export var ctaLabel = "_fg-b";
export var eyebrow = "_fg-3";
export var howTo = "_fg-6";
export var image = "_fg-e";
export var modal = "_fg-0";
export var socialButton = "_fg-d";
export var stepCard = "_fg-8";
export var stepLabel = "_fg-a";
export var stepNumber = "_fg-9";
export var steps = "_fg-7";
export var title = "_fg-4";